import { useEffect, useState } from "react";
import { X } from "lucide-react";
import api from "@/lib/api";
import { Secondary } from "@/components/backoffice/kit";

const ANSWERS = [
    ["How consignment works and the 20% split", "Leave \"13thav prints\" on and 13thav prints, packs and ships the order under your brand. You keep 20% of the standard price plus 100% of any markup you add."],
    ["When I get paid", "Card money for the jobs you print lands in your own Stripe account on Stripe's schedule. Your consignment share is paid out weekly — see Payouts."],
    ["How to change a price", "Products → tap the product. With 13thav prints ON you set a Markup %. With it OFF you set Your price. Save."],
    ["How to add my own product", "Products → Add product → My own product. Photo, name, price, sizes, designer on or off, a note example. Save."],
    ["How to use my own domain", "Branding → Use my own domain → type it → Check. Paste the two records we show at your registrar; we finish the certificate."],
    ["How to send a proof", "Open the order → Send proof → pick an image or upload one → Send. The customer approves on their phone; the badge turns Approved."],
];

/** 8.9 Help — a panel, not a page. Text or email 13thav, six one-line answers, Back closes it. */
export default function HelpPanel({ onClose, platform = false }) {
    const [biz, setBiz] = useState({});
    useEffect(() => { api.get("/settings").then(({ data }) => setBiz(data?.business || {})).catch(() => { }); }, []);
    const phone = (biz.phone || "(347) 573-3875").replace(/[^\d+]/g, "");
    const email = biz.email || "hello@13thav.com";
    return (
        <div className="fixed inset-0 z-[60] flex justify-end bg-[#1a1a1a]/40" role="dialog" aria-modal="true" data-testid="help-panel">
            <div className="flex h-full w-full max-w-md flex-col overflow-y-auto border-l border-[#1a1a1a] bg-white p-4">
                <div className="mb-3 flex items-center justify-between">
                    <h2 className="text-[18px] font-semibold">Help</h2>
                    <button onClick={onClose} aria-label="Close help" data-testid="help-close-x" className="flex h-11 w-11 items-center justify-center border border-[#1a1a1a]"><X size={18} /></button>
                </div>
                {!platform && (
                    <div className="grid grid-cols-2 gap-2">
                        <Secondary href={`sms:${phone}`} testid="help-text">Text 13thav</Secondary>
                        <Secondary href={`mailto:${email}`} testid="help-email">Email 13thav</Secondary>
                    </div>
                )}
                <ul className="mt-4 divide-y divide-[#767676] border-y border-[#767676]" data-testid="help-answers">
                    {ANSWERS.map(([q, a]) => (
                        <li key={q} className="py-3">
                            <p className="text-[15px] font-semibold">{q}</p>
                            <p className="text-[15px] text-[#4d4d4d]">{a}</p>
                        </li>
                    ))}
                </ul>
                <div className="mt-auto pt-4">
                    <Secondary onClick={onClose} testid="help-back" full>Back</Secondary>
                </div>
            </div>
        </div>
    );
}
